import { SupportedLanguages } from '@/lang/lang-settings';
import { IntegrationMonitoringTranslations } from './models/integration-monitoring-translaction-model';
import { ptBR } from './translactions/pt-BR';
import { enUS } from './translactions/en-US';

// eslint-disable-next-line import/prefer-default-export
export const integrationMonitoring: Record<SupportedLanguages, IntegrationMonitoringTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
